
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6636d6cb1c9e4d4e9800f993";
              window.beaePageSetting.pageTitle = "New Shop by Category 2.0"; 
              window.beaePageSetting.pageType = "section";

          let js_8Q66TOEJ = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-9xn02tgwsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9xn02tgw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9xn02tgw');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var n,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let r=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(n=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||n.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+r+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),s=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),r=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(a){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);n&&(a.innerHTML=n.html,r.push("desktop"))}}else if(s){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,s);n&&(s.innerHTML=n.html,r.push("mobile"))}}(a||s)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!r.includes("desktop")&&window.innerWidth>=768&&a){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);n&&(a.innerHTML=n.html,r.push("desktop"))}if(!r.includes("mobile")&&window.innerWidth<768&&s){const n=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,s);n&&(s.innerHTML=n.html,r.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((r,n)=>{r.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),n.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9xn02tgw: ', ex)
      };
    

      try {
        let argid = 'beae-9xn02tgwsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9xn02tgw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9xn02tgw');
        args.el = args.els[0];
        ((p) => { window.BeaeSlider&&!p.noRunJs&&window.BeaeSlider(p) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9xn02tgw: ', ex)
      };
    

      try {
        let argid = 'beae-ro5sb91ygrid-container-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ro5sb91y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ro5sb91y');
        args.el = args.els[0];
        ((B) => { if(B.mode.value=="live"){const S=B.el.querySelector('.beae-section-background-video[data-device="desktop"]'),L=B.el.querySelector('.beae-section-background-video[data-device="mobile"]'),T=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(S){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideo,S);M&&(S.innerHTML=M.html,T.push("desktop"))}}else if(L){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideoMobile,L);M&&(L.innerHTML=M.html,T.push("mobile"))}}(S||L)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!T.includes("desktop")&&window.innerWidth>=768&&S){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideo,S);M&&(S.innerHTML=M.html,T.push("desktop"))}if(!T.includes("mobile")&&window.innerWidth<768&&L){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideoMobile,L);M&&(L.innerHTML=M.html,T.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ro5sb91y: ', ex)
      };
    

      try {
        let argid = 'beae-bhyzforigrid-container-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bhyzfori',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bhyzfori');
        args.el = args.els[0];
        ((B) => { if(B.mode.value=="live"){const S=B.el.querySelector('.beae-section-background-video[data-device="desktop"]'),L=B.el.querySelector('.beae-section-background-video[data-device="mobile"]'),T=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(S){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideo,S);M&&(S.innerHTML=M.html,T.push("desktop"))}}else if(L){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideoMobile,L);M&&(L.innerHTML=M.html,T.push("mobile"))}}(S||L)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!T.includes("desktop")&&window.innerWidth>=768&&S){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideo,S);M&&(S.innerHTML=M.html,T.push("desktop"))}if(!T.includes("mobile")&&window.innerWidth<768&&L){const M=window.BEAEVIDEO.convertBackgroundSection(B.optionsVideoMobile,L);M&&(L.innerHTML=M.html,T.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bhyzfori: ', ex)
      };
    }; if (window.BEAEBASE) {js_8Q66TOEJ()} else {window.BEAEPAGEJS.push(js_8Q66TOEJ)} })(); 